export const initialQuantity = 10;
export const additionalQuantity = 10;